// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3iN9v","inputWrap":"CustomTip_inputWrap__1dzGy"};